var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDepartmentPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.57 4.82031L12.64 7.26031V12.3503L8.57 14.7903L4.49 12.3503V7.26031L8.57 4.82031ZM2.99 7.26031V12.3503C2.99 12.8803 3.27 13.3703 3.72 13.6403L7.8 16.0803C8.27 16.3603 8.87 16.3603 9.34 16.0803L13.41 13.6403C13.86 13.3703 14.14 12.8803 14.14 12.3503V7.26031C14.14 6.73031 13.86 6.24031 13.41 5.97031L9.34 3.53031C8.87 3.25031 8.27 3.25031 7.8 3.53031L3.72 5.97031C3.27 6.24031 2.99 6.73031 2.99 7.26031Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 19.1803H2V20.6803H23V19.1803Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 6.44031H20V3.44031H18.5V6.44031H15.5V7.94031H18.5V10.9403H20V7.94031H23V6.44031Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDepartmentPlus);
export default __webpack_public_path__ + "static/media/ic-department-plus.a1261a3d8924aa8934013deb95860f37.svg";
export { ForwardRef as ReactComponent };